import { c as _c } from "react/compiler-runtime";
import { SlidersHorizontal } from 'lucide-react';
import type { FilterSection } from './filter-sort-drawer';
import { FilterMobileDrawer } from './filter-sort-drawer';
interface CollectionToolbarProps {
  productCount?: number;
  filterSections?: FilterSection[];
}

/**
 * Toolbar for the collection page.
 * Mobile: "Filter and sort" button (opens drawer) + product count on same row.
 * Desktop: just product count (displayed above the grid, sidebar handles filtering).
 */
export function CollectionToolbar(t0) {
  const $ = _c(8);
  const {
    productCount,
    filterSections
  } = t0;
  let t1;
  if ($[0] !== filterSections) {
    t1 = <FilterMobileDrawer filterSections={filterSections} />;
    $[0] = filterSections;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="hidden lg:block" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== productCount) {
    t3 = productCount !== undefined && <p className="text-sm text-neutral-500">{productCount} product{productCount !== 1 ? "s" : ""}</p>;
    $[3] = productCount;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <div className="mb-6 flex items-center justify-between border-b border-neutral-200 py-4">{t1}{t2}{t3}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
interface CollectionToolbarStaticFallbackProps {
  productCount?: number;
  activeFilterCount?: number;
}

/**
 * Server-renderable twin of <CollectionToolbar> used as the Suspense fallback
 * while the client-side FilterMobileDrawer is pending. Reserves the toolbar's
 * box in the first paint so the grid below doesn't shift once the drawer
 * hydrates. Label matches the hydrated state ("Filter & Sort" or
 * "Filters (N)") when an accurate count is threaded in from the page.
 */
export function CollectionToolbarStaticFallback(t0) {
  const $ = _c(9);
  const {
    productCount,
    activeFilterCount: t1
  } = t0;
  const activeFilterCount = t1 === undefined ? 0 : t1;
  const label = activeFilterCount > 0 ? `Filters (${activeFilterCount})` : "Filter & Sort";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SlidersHorizontal className="h-4 w-4" aria-hidden="true" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== label) {
    t3 = <span className="flex items-center gap-1.5 text-neutral-900 lg:hidden">{t2}<span className="text-[11px] font-bold uppercase tracking-[0.15em]">{label}</span></span>;
    $[1] = label;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="hidden lg:block" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== productCount) {
    t5 = productCount !== undefined && <p className="text-sm text-neutral-500">{productCount} product{productCount !== 1 ? "s" : ""}</p>;
    $[4] = productCount;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t5) {
    t6 = <div className="mb-6 flex items-center justify-between border-b border-neutral-200 py-4">{t3}{t4}{t5}</div>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}